/**
 * @param {Number} howLong - time to sleep in milliseconds
 * @return {Promise<void>}
 */
export default function sleep( howLong ) {
	return new Promise( resolve => {
		setTimeout( () => {
			resolve();
		}, howLong );
	} );
}
